import { ReactNode } from "react";
import { useSubscription } from "@/hooks/use-subscription";
import { UpgradePrompt } from "@/components/subscription/UpgradePrompt";

interface FeatureGateProps {
  feature: string;
  currentCount?: number;
  fallback?: ReactNode;
  children: ReactNode;
}

export function FeatureGate({ feature, currentCount, fallback, children }: FeatureGateProps) {
  const { canAccess, isWithinLimit, isLoading } = useSubscription();

  if (isLoading) return null;

  const hasAccess = currentCount !== undefined
    ? isWithinLimit(feature, currentCount)
    : canAccess(feature);

  if (hasAccess) return <>{children}</>;

  if (fallback) return <>{fallback}</>;

  return <UpgradePrompt feature={feature} />;
}
